import { ReceptivenessForm } from '../../features/receptiveness'
import { RouteProps } from '../../routes/AppRouter'
import { Title } from '../../components/common/Title'
import { TITLE_RECEPTIVENESS } from '../../routes/title-constants'
import { useTranslation } from 'react-i18next'

export const Form = (props: RouteProps) => {
  const { t } = useTranslation()

  return (
    <>
      <Title title={t(TITLE_RECEPTIVENESS)} color={props.color} />
      <ReceptivenessForm />
    </>
  )
}
